import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar/Snackbar';
import * as notificationsSelectors from 'data/notifications/notificationsSelectors';
import * as notificationsActions from 'data/notifications/notificationsActions';
import { getFeatureFlag } from 'utils/featureFlags/selectors';

const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(notificationsSelectors.getNotifications);
  const notificationsEnabled = useSelector((state) => getFeatureFlag(state, 'notifications'));

  function onClose(id) {
    dispatch(notificationsActions.removeNotifications([id]));
  }

  return (
    <>
      {notificationsEnabled && notifications && notifications.toIndexedSeq().map((notification, index) => (
        <Snackbar
          key={notification.id}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open
          style={{
            right: 20,
            top: index * 70 + 20,
          }}
          autoHideDuration={notification.autoHideDuration || 10000}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              onClose(notification.id);
            }
          }}
        >
          {notification.snackbarContent &&
          <notification.snackbarContent
            onClose={() => onClose(notification.id)}
            {...notification.snackbarContentProps}
          />
          }
        </Snackbar>
      ))}
    </>
  );
};

export default Notifications;

